// Single source of truth for business/protocol literals shared across the portal.
// Values here are identical to the literals they replace; changing them changes behavior.

export const CLIENT_TYPES = {
  INDIVIDUAL: 'individual',
  ORGANIZATION: 'organization',
  PARTNER: 'partner',
} as const;

export type ClientType = (typeof CLIENT_TYPES)[keyof typeof CLIENT_TYPES];

// Client types that can self-register through the public signup form.
export type SignupClientType = typeof CLIENT_TYPES.INDIVIDUAL | typeof CLIENT_TYPES.ORGANIZATION;

export const USER_STATUS = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
  INVITED: 'invited',
} as const;

// Wildcard sentinel for "all facilities" / "all areas" scope (backend contract).
export const SCOPE_WILDCARD = '*';

export const CHALLENGE = {
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
} as const;

// OAuth token-type value and the query-param names used on redirect callbacks.
export const OAUTH = {
  TOKEN_TYPE: 'Bearer',
  PARAM: {
    STATE: 'state',
    ID_TOKEN: 'id_token',
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    TOKEN_TYPE: 'token_type',
    EXPIRES_IN: 'expires_in',
    REDIRECT_URI: 'redirect_uri',
  },
} as const;

export const PERMISSIONS = {
  MANAGE_USERS: 'manage:users',
  MANAGE_FACILITIES: 'manage:facilities',
} as const;

// Per-client master role id convention (mirrors backend user_guards.master_role_id).
export function masterRoleId(clientId: string): string {
  return `role_${clientId}_master`;
}

// Admin section routes.
export const ADMIN_ROUTES = {
  USERS: '/admin/users',
  INSTANCES: '/admin/instances',
  ACCOUNT: '/admin/account',
} as const;

// Post-login "partner" flag on the /welcome route (?partner=1).
export const PARTNER_QUERY_KEY = 'partner';
export const PARTNER_QUERY_ACTIVE = '1';
